import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onChange", "minRows", "maxRows", "inputRef", "size", "value", "width", "invalid", "hasCounter"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { clsx } from 'clsx';
import { useInputSize } from '../../../internal/hooks';
import { TextareaAutosize } from '../../internal/components';
import { calcValueLength, getFormattedCounterText } from '../../internal/utils';
import { getStyles } from './styles';
import { FocusObserver } from '../../../internal/components/FocusObserver/FocusObserver';
import { FocusSource } from '../../../internal/types';

/**
 * Компонент textarea.
 * Автоматически подстраивает свою высоту под количество введеного текста.
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=39167-25544&t=dWJSsCGr4smKrzpW-4)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Textarea = /*#__PURE__*/React.forwardRef(function Textarea(props, ref) {
  const {
      onChange,
      minRows,
      maxRows,
      inputRef: inputRefProp,
      size: sizeProp,
      value,
      width,
      invalid,
      hasCounter
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    maxLength
  } = props;
  const handleRef = useForkRef(ref, inputRefProp);
  const size = useInputSize(sizeProp);
  const styles = getStyles(size);
  const [length, setLength] = React.useState(calcValueLength(value));
  const [focus, setFocus] = React.useState({
    focused: false,
    source: FocusSource.mouse
  });
  const focusStyle = focus.source === FocusSource.keyboard ? styles['focused_keyboard'] : styles['focused_mouse'];
  React.useEffect(() => {
    // отдельный useEffect нужен для контроля значения длины при программном изменении value
    // т.к. без пользовательского взаимодействия с компонентом handleChange не вызывается
    setLength(calcValueLength(value));
  }, [value]);
  const handleChange = e => {
    if (onChange) {
      onChange(e, e.currentTarget.value);
    }
    setLength(e.currentTarget.value.length);
  };
  const handleFocus = (focused, source) => {
    setFocus({
      focused,
      source
    });
  };
  const textareaAutosize = /*#__PURE__*/_jsx(FocusObserver, {
    onFocus: handleFocus,
    children: /*#__PURE__*/_jsx(TextareaAutosize, _objectSpread(_objectSpread({}, rest), {}, {
      ref: handleRef,
      value: value,
      className: clsx(styles['textarea'], invalid && styles['invalid'], hasCounter && styles['withCounter'], focus.focused && focusStyle),
      onChange: handleChange,
      minRows: minRows,
      maxRows: maxRows,
      style: {
        width
      }
    }))
  });
  return hasCounter ? /*#__PURE__*/_jsxs("div", {
    className: styles['counterWrapper'],
    children: [textareaAutosize, /*#__PURE__*/_jsx("div", {
      className: styles['counter'],
      children: getFormattedCounterText(length, maxLength)
    })]
  }) : textareaAutosize;
});